import { lazyImport } from '@/utils/lazyImport';
import { MainLayout, SideNavigationItem } from '@/components/Layout';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {
  ArrowTrendingUpIcon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  HomeIcon,
  HomeModernIcon,
  LockClosedIcon,
  StarIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import AdminLoader from '@/components/Elements/Loader/AdminLoader';
// import { InquiryList } from './routes/Inquiry/InquiryList';
import { ViewInquiry } from './routes/Inquiry/ViewInquiry';
import { Chat } from './routes/chat/Chat';
import prf from '@/assets/prf-icon.svg';
import inquiry from '@/assets/inq.svg';
import lead from '@/assets/lead.svg';
import dash from '@/assets/dash.svg';
import sub from '@/assets/sub.svg';
import star from '@/assets/star.svg';
import pass from '@/assets/pass.svg';
import req from '@/assets/req.svg';
import { SignedContract } from './routes/signedContract/SignedContract';
import { HelpSupport } from './routes/HelpSupport/HelpSupport';
import AddTicket from './routes/HelpSupport/AddTicket';
import ViewHelpSupport from './routes/HelpSupport/ViewHelpSupport';
// import { StripePayment } from '@/components/Agency_payment/Stripe/StripePayment';
// import { SubscriptionType } from './routes/SubscriptionAgency/SubscriptionType';
// import SubscriptionType } from './routes/SubscriptionAgency/SubscriptionType';
// import { TeamAgencys } from './routes/TeamAgency/TeamAgencys';
//import { AgencyProfile } from './auth/routes/AgencyProfile';
// import { AgencyLeads } from './routes/Leads/AgencyLeads';
// import { SubScriptionPayment } from './routes/SubscriptionAgency/SubScriptionPayment';
// import { AgencyChangePassword } from './auth/routes/AgencyResetPassword';
// import { MyRatings } from './routes/MyRatings/MyRatings';
// import { AgencyDashboard } from './routes/AgencyDashboard';

const { StripePayment } = lazyImport(
  () => import('@/components/Agency_payment/Stripe/StripePayment'),
  'StripePayment'
);
const { SubscriptionType } = lazyImport(
  () => import('./routes/SubscriptionAgency/SubscriptionType'),
  'SubscriptionType'
);

const { TeamAgencys } = lazyImport(() => import('./routes/TeamAgency/TeamAgencys'), 'TeamAgencys');
const { AgencyProfile } = lazyImport(() => import('./auth/routes/AgencyProfile'), 'AgencyProfile');

const { Agencyprofile } = lazyImport(
  () => import('./routes/ProfileAgency/Agencyprofile'),
  'Agencyprofile'
);
const { AgencyLeads } = lazyImport(() => import('./routes/Leads/AgencyLeads'), 'AgencyLeads');
const { SubScriptionPayment } = lazyImport(
  () => import('./routes/SubscriptionAgency/SubScriptionPayment'),
  'SubScriptionPayment'
);
const { AgencyChangePassword } = lazyImport(
  () => import('./auth/routes/AgencyResetPassword'),
  'AgencyChangePassword'
);
const { MyRatings } = lazyImport(() => import('./routes/MyRatings/MyRatings'), 'MyRatings');

const { AgencyDashboard } = lazyImport(() => import('@/features/agency/routes'), 'AgencyDashboard');
const { AllNotifiationsAgency } = lazyImport(
  () => import('@/features/agency/routes/NotificationAgency/AllNotifiationsAgency'),
  'AllNotifiationsAgency'
);

const { Inquiries } = lazyImport(() => import('@/features/agency/routes'), 'Inquiries');

const { InquiryList } = lazyImport(
  () => import('@/features/agency/routes/Inquiry/InquiryList'),
  'InquiryList'
);
const { TeamAgencyDetails } = lazyImport(
  () => import('@/features/agency/routes/TeamAgency/TeamAgencyDetails'),
  'TeamAgencyDetails'
);

const { Advertisement } = lazyImport(
  () => import('@/features/misc/routes/PropertyProject_v2/PropertyProjects'),
  'Advertisement'
);

const { PropertyForRent: PropForRent } = lazyImport(
  () => import('@/features/misc/routes/v2/PropertyForRent'),
  'PropertyForRent'
);

const { PropertyForSale } = lazyImport(
  () => import('@/features/misc/routes/v2/PropertyForSale'),
  'PropertyForSale'
);

const { PropertyForTeanet } = lazyImport(
  () => import('@/features/misc/routes/v2/PropertyForTeanet'),
  'PropertyForTeanet'
);
const { CompaniesSeekingEquity } = lazyImport(
  () => import('@/features/misc/routes/v2/CompaniesSeekingEquity'),
  'CompaniesSeekingEquity'
);
const { HouseInvestor } = lazyImport(
  () => import('@/features/misc/routes/v2/houseInvestors'),
  'HouseInvestor'
);
const { BussnesForSale } = lazyImport(
  () => import('@/features/misc/routes/v2/bussnesForSale.tsx'),
  'BussnesForSale'
);

export const publicRoutes = [];
export const protectedRoutes = [];

const App = () => {
  const navigation = [
    { name: 'Dashboard', to: './agency-dashboard', icon: HomeIcon },
    { name: 'Profile', to: './profile', icon: UserIcon },
    { name: 'Property Requests', to: './property-requests', icon: HomeModernIcon },
    { name: 'Inquiries', to: './inquiries', icon: DocumentTextIcon },
    { name: 'Leads', to: './leads', icon: ArrowTrendingUpIcon },
    { name: 'Subscription', to: './subscription', icon: CurrencyDollarIcon },
    { name: 'Ratings & Reviews', to: './ratings-reviews', icon: StarIcon },
    { name: 'Change Password', to: './reset-password', icon: LockClosedIcon },

    // { name: 'Dashboard', to: '.', icon: HomeIcon },
    // { name: 'Report', to: './admin-report', icon: HomeIcon },
    // { name: 'General Settings', to: './general-settings', icon: HomeIcon },
  ];

  navigation.filter(Boolean) as SideNavigationItem[];

  return (
    <MainLayout navigation={navigation}>
      <Suspense
        fallback={
          <div className="h-full w-full">
            <AdminLoader />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};
export const agencyRoutes = [
  {
    path: '/agency',
    element: <App />,
    children: [
      { path: '', element: <AgencyProfile /> },
      { path: 'property-requests', element: <TeamAgencys /> },
      { path: 'property-requests-details', element: <TeamAgencyDetails /> },
      { path: 'profile', element: <AgencyProfile /> },
      { path: 'inquiries', element: <InquiryList /> },
      { path: 'inquiry-details', element: <ViewInquiry /> },
      { path: 'reset-password', element: <AgencyChangePassword /> },
      { path: '*', element: <Navigate to="." /> },
      { path: 'agency-notification', element: <AllNotifiationsAgency /> },
      { path: 'chat', element: <Chat /> },

      { path: 'subscription-type', element: <SubscriptionType /> },
      { path: 'subscription-select-payment/:id', element: <SubScriptionPayment /> },
      { path: 'subscription-payment/:id', element: <StripePayment /> },
      { path: 'leads', element: <AgencyLeads /> },
      { path: 'subscription', element: <SubscriptionType /> },
      { path: 'agency-dashboard', element: <AgencyDashboard /> },
      { path: 'ratings-reviews', element: <MyRatings /> },
      { path: 'contract-list', element: <SignedContract /> },
      { path: 'help-support', element: <HelpSupport /> },
      { path: 'add-ticket', element: <AddTicket /> },
      { path: 'help-support-details', element: <ViewHelpSupport /> },
      { path: 'create-property-project', element: <Advertisement /> },
      { path: 'add-property-for-sale', element: <PropertyForSale /> },
      { path: 'add-property-for-rent', element: <PropForRent /> },
      { path: 'create-business', element: <BussnesForSale /> },
      { path: 'house-investment', element: <HouseInvestor /> },
      { path: 'house-wanted-for-rent', element: <PropertyForTeanet /> },
      { path: 'company-seeking-equity', element: <CompaniesSeekingEquity /> },
      // { path: 'general-settings', element: <GeneralSetting /> },
      // { path: 'users/:id', element: <User /> },
      // { path: 'edit-item/:id', element: <EditUser /> },
      // { path: 'inquiry/:id', element: <Inquiry /> },
      // { path: 'completed-deals-listings', element: <MyDealsAdminList /> },
      // { path: 'completed-deals-details/:id', element: <MyDealsAdmin /> },
      // { path: 'completed-deals-details', element: <MyDealsAdmin /> },
    ],
  },
];
